
import { RtcData } from "@/domain/entities/CargoV2";
import { Options, prop, Vue } from "vue-class-component";
import CargoV2EditHeaderActions from "../edit/cargo-v2-edit-header-actions.vue";
import CargoV2EditHeaderTitle from "../edit/cargo-v2-edit-header-title.vue";
import { formatDate, formatDateNormal } from "@/app/infrastructures/misc/Utils";
import { CargoV2Controller } from "@/app/ui/controllers/CargoV2Controller";

class Props {
  detailData = prop<RtcData>({
    default: () => new RtcData(),
    type: Object
  });
  isDisabledBookingBtn = prop<boolean>({
    default: false,
    type: Boolean
  });
  isDisabledSearchFlightBtn = prop<boolean>({
    default: false,
    type: Boolean
  });
  isShowSearchFlightBtn = prop<boolean>({
    default: false,
    type: Boolean
  });
  disabledSelectSchedule = prop<boolean>({
    default: false,
    type: Boolean
  });
  disabledBooking = prop<boolean>({
    default: false,
    type: Boolean
  });
  disabledChangeTransport = prop<boolean>({
    default: false,
    type: Boolean
  });
  showSelectSchedule = prop<boolean>({
    default: false,
    type: Boolean
  });
  cargoType = prop<string>({
    default: "",
    type: String
  });
}

@Options({
  components: {
    CargoV2EditHeaderActions,
    CargoV2EditHeaderTitle
  }
})
class CreateCargoNonRTCLayout extends Vue.with(Props) {
  get form() {
    return CargoV2Controller.form;
  }

  get formattedDepartureDate() {
    if (this.cargoType !== this.detailData.cargoType) return "";
    if (this.cargoType !== "plane") return "";
    if (this.detailData.isMoreThanCutOffTime && !this.detailData.nextRtcFlightConfig?.cargo_flight_departure_hour) return "";
    if (this.form.cargoNo && this.form.cargoVehicleNo) {
      return formatDate(
        this.form.departureDate,
        "DD MMM YYYY • HH:mm"
      );
    }
    return formatDate(
      CargoV2Controller.departureDate,
      "DD MMM YYYY • HH:mm"
    );
  }
}
export default CreateCargoNonRTCLayout;
